function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTbAppIconUnread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z",
    "data-name": "Path 1336",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 2a8 8 0 1 0 8 8 8 8 0 0 0-8-8m.8 12H9.2V9.2h1.6zm0-6.4H9.2V6h1.6z",
    "data-name": "Path 1337",
    style: {
      fill: "#e6c029"
    },
    transform: "rotate(180 10 10)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbAppIconUnread);
export default __webpack_public_path__ + "static/media/tb_app_icon_unread.18f8012a8454149ba78895437c8d6985.svg";
export { ForwardRef as ReactComponent };